
eval("define(\'text!oroui/templates/widget-picker/widget-picker-modal-template.html\',[],function () { return \'<div class=\"widget-picker-search\"></div>\\n<div class=\"widget-picker-containers\"></div>\\n\';});\n\n//# sourceURL=/text!oroui/templates/widget-picker/widget-picker-modal-template.html");

